export const EyeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M11.9 5.73921C11.835 5.56471 10.25 1.47021 6 1.47021C1.75 1.47021 0.163 5.56471 0.1 5.73921L0 6.00021L0.1 6.26122C0.165 6.43572 1.75 10.5302 6 10.5302C10.25 10.5302 11.837 6.43572 11.9 6.26122L12 6.00021L11.9 5.73921ZM6 9.04271C3.291 9.04271 1.9795 6.78571 1.605 6.00021C1.9805 5.21271 3.2925 2.95771 6 2.95771C8.7075 2.95771 10.019 5.21221 10.395 6.00021C10.019 6.78821 8.7075 9.04271 6 9.04271Z"
      fill="currentColor"
    />
    <path
      d="M6 8C7.10457 8 8 7.10457 8 6C8 4.89543 7.10457 4 6 4C4.89543 4 4 4.89543 4 6C4 7.10457 4.89543 8 6 8Z"
      fill="currentColor"
    />
  </svg>
);
